
const swiper = new Swiper('.swiper', {
    keyboard: {
        enabled: true,
    },
    direction: 'vertical',
    loop: false,
    cssMode: window.innerWidth <= 560,
    mousewheel: true,

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
        clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next-custom',
        prevEl: '.swiper-button-prev-custom',
    },
});


/**
 * Clamp a number between two values
 * @type {function(number: number, lower: number, upper: number): number}
 */
Math.clamp = Math.clamp || function (number, lower, upper) {
    return this.min(this.max(number, lower), upper);
}

class ScrollStuff {

    constructor() {
        // this.scrollHeight = window.innerHeight;
        document.documentElement.setAttribute("lang", lang);


        this.reviewButton = document.querySelector('.review-button');

        // Review Config
        this.reviewContainer = document.querySelector('.swiper-wrapper');
        this.reviewItemHeight = document.querySelector('.actual-review').offsetHeight;



        this.filterSelect = document.querySelector('.filter-select');
        this.filterSelect.addEventListener('change', this.filterReviews.bind(this))

        this.reviewItem = Array.from(this.reviewContainer.children);

        this.filterReviews();
    }

    /**
     * Sorts reviews based on what filter you've selected.
     * @void
     */
    filterReviews() {
        switch ( this.filterSelect.value ) {
            case 'most-recent':
                this.reviewItem.sort( (a, b) =>
                    new Date(b.dataset.date) - new Date(a.dataset.date)
                );
                break;

            case 'oldest':
                this.reviewItem.sort( (a, b) =>
                    new Date(a.dataset.date) - new Date(b.dataset.date)
                );
                break;

            case 'high':
                this.reviewItem.sort( (a, b) =>
                    b.dataset.score - a.dataset.score
                );
                break;

            case 'low':
                this.reviewItem.sort( (a, b) =>
                    a.dataset.score - b.dataset.score
                );
                break;

            default:
                this.reviewItem.sort( (a, b) =>
                    new Date(b.dataset.date) - new Date(a.dataset.date)
                );
                break;
        }

        this.genReviews();

        setTimeout(() => swiper.slideTo(0), 50)
    }


    /**
     * Reloads all reviews, and scrolls back to the first review.
     * @void
     */
    genReviews() {
        for (let i = 0, l = this.reviewItem.length; i < l; i++) {
            this.reviewContainer.appendChild(this.reviewItem[i]);

            const reactionContent = this.reviewItem[i].querySelector('.reaction-content');
            const reviewContent = this.reviewItem[i].querySelector('.review-content');

            if ( reviewContent?.innerHTML.length > 200 ) {
                reviewContent.style.fontSize = window.innerWidth > 400 ? '1em' : '.7em';
            }

            if ( reviewContent?.innerHTML.length > 600 ) {
                reviewContent.parentNode.classList.add('display-none');
            }

            if ( reactionContent?.innerHTML.length > 200 ) {
                reactionContent.style.fontSize = window.innerWidth > 400 ? '1em' : '.7em';
            }

        }
    }
}

new ScrollStuff;
